import { render, staticRenderFns } from "./DesktopView.vue?vue&type=template&id=7303d588&scoped=true"
import script from "./DesktopView.vue?vue&type=script&lang=js"
export * from "./DesktopView.vue?vue&type=script&lang=js"
import style0 from "./DesktopView.vue?vue&type=style&index=0&id=7303d588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7303d588",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductListFiltersCategoryFilters: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/Product/List/Filters/CategoryFilters.vue').default})
